export default "__VITE_ASSET__d932aed6__"